"use strict";

exports.__esModule = true;
exports.CreateDashboardScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DashboardDataProvider = require("../DashboardDataProvider");
var _Core = require("../../Core");
var _App = require("../../App");
var _DashboardEditor = require("../DashboardEditor");
var _DashboardCollection = require("../DashboardCollection");
var _System = require("../../../System");
var _CreateDashboardWizard = require("../CreateDashboardWizard");
var _Theme = require("../../Theme");
var _Notifications = require("../../Notifications");
var _DashboardTagContext = require("../DashboardTagContext");
var _Widgets = require("../../Widgets");
var _Utils = require("../../../Utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "CreateDashboardScreen__Container",
  componentId: "sc-1w82ynd-0"
})(["background:", ";height:calc(100vh - ", ");padding:4rem;display:flex;justify-content:center;"], (0, _Theme.val)("WorkspaceBackground"), (0, _Theme.val)("NavbarHeight"));

/**
 * Screen which allows users to create new dashboards.
 */

var CreateDashboardScreen = exports.CreateDashboardScreen = function CreateDashboardScreen(props) {
  var widgets = _react["default"].useContext(_Widgets.WidgetsContext);
  var history = props.history;
  var body;
  var _useState = (0, _react.useState)(undefined),
    config = _useState[0],
    setConfig = _useState[1];
  var dashboardCollection = _react["default"].useContext(_DashboardCollection.DashboardCollectionContext);
  var _React$useContext = _react["default"].useContext(_Notifications.NotificationContext),
    showNotification = _React$useContext.showNotification;
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  var handleWizardSubmit = function handleWizardSubmit(config) {
    var name = config.name,
      description = config.description,
      tags = config.tags,
      template = config.template;
    setConfig({
      id: "",
      name: name,
      tags: tags,
      element: Object.assign({}, template.element, {
        props: Object.assign({}, template.element.props, {
          description: description
        })
      })
    });
  };
  var handleSubmit = function handleSubmit(dashboard) {
    var name = dashboard.name,
      tags = dashboard.tags,
      element = dashboard.element;
    var id = (0, _Utils.convertToID)(name);
    return dashboardCollection.create({
      id: id,
      name: name,
      tags: tags,
      element: element
    }).then(function (result) {
      history.push((0, _System.getScreenURL)("DashboardList", result));
      showNotification(_Notifications.NOTIFICATION_CREATED_DASHBOARD);
    });
  };
  if (config !== undefined) {
    body = /*#__PURE__*/_react["default"].createElement(_DashboardDataProvider.DashboardDataProvider, {
      dashboard: config,
      defaultToFirstDevice: true
    }, /*#__PURE__*/_react["default"].createElement(_Core.DragDropContextProvider, null, /*#__PURE__*/_react["default"].createElement(_DashboardEditor.DashboardEditor, {
      dashboardCollection: dashboardCollection,
      widgets: widgets.dashboardWidgets,
      onSubmit: handleSubmit,
      value: config
    })));
  } else {
    body = /*#__PURE__*/_react["default"].createElement(Container, null, /*#__PURE__*/_react["default"].createElement(_CreateDashboardWizard.CreateDashboardWizard.Form, {
      "data-testid": "CreateDashboardWizard",
      onSubmit: handleWizardSubmit,
      initialValues: {}
    }, /*#__PURE__*/_react["default"].createElement(_CreateDashboardWizard.CreateDashboardWizard.CurrentStep, null)));
  }
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CreateDashboardScreen.title", "Create new Dashboard"),
    "data-testid": "CreateDashboardScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("CreateDashboardScreen.navbar.title", "Create Dashboard")
  }), /*#__PURE__*/_react["default"].createElement(_DashboardTagContext.DashboardTagContext.Provider, null, body));
};